/* src/app/components/game-layer/campaign-info-component/campaign-info-component.css */
.campaign-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0;
}
.campaign-summary > div {
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.04);
  color: var(--ink);
}
.campaign-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--ink);
  margin-bottom: 16px;
}
.campaign-player-list {
  margin-top: 18px;
}
.campaign-player-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  margin-top: 10px;
  border-radius: 12px;
  border: 1px solid rgba(240, 215, 122, 0.12);
  background: rgba(255, 255, 255, 0.04);
}
.validation-text {
  color: #ffb8a2;
}
/*# sourceMappingURL=campaign-info-component.css.map */
